export const contentWrapper = 'h-full overflow-y-auto bg-white';
export const avatarWrapper = 'w-full inline-flex justify-center pt-8';
export const chipsWrapper =
  'w-full mt-10 flex flex-row gap-2 justify-center items-center';
export const contactButtons = 'flex justify-start mt-4 gap-3';
export const buttonIconStyle = 'h-5 w-5 text-primary';
export const infoWrapper = 'mt-2 w-11/12 mx-auto flex-column items-center';
export const actionIcon = 'h-4 w-4 text-secondary';
